import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = [
    "modal",
    "companyNoLabelAsterix",
    "vatNoLabelAsterix",
    "organizationLabelAsterix",
    "organizationErrorBlock",
    "vatNoErrorBlock",
    "companyNoErrorBlock"
  ];

  connect() {
    this.initializeControls();
    this.emailSyncWithModal();
    if (this.shouldOpenModal()) {
      this.openModal();
    }
    if (this.shouldOpenReviewModal()) {
      this.openReviewModal();
    }
  }

  initializeControls() {
    const sendButton = document.querySelector('.send-btn');
    sendButton?.addEventListener("click", () => {
      this.sendAsGuest();
    });
  }

  emailSyncWithModal() {
    const bookingEmailInput = document.getElementById('email');
    const modalEmailInput = document.getElementById('user_modal_email');

    bookingEmailInput.addEventListener('input', function () {
        modalEmailInput.value = bookingEmailInput.value;
    });
  }

  shouldOpenModal() {
    return window.location.search.includes('modal_message_sent=true')
  }

  shouldOpenReviewModal() {
    const withoutUser = $(".navbar-nav").length > 0;
    const alertText = $(".alert-info span").text();
    const verificationSent = this.data.element.dataset.verification_resent;
    const verificationResent = this.data.element.dataset.verification_sent;
    return (
        withoutUser &&
        !alertText.includes(verificationSent) &&
        !alertText.includes(verificationResent)
    );
  }

  openModal() {
    $('#modal__message_sent').modal('show');

    setTimeout(function() {
      window.history.replaceState({}, document.title,window.location.href.split("?")[0]);
    },0);
  }

  openReviewModal() {
    $('#modal__review_email').modal('show');
  }

  onChangeBusinessType() {
    const show_asterisk = document.getElementById('booking_show_asterisk').value
    if (show_asterisk === "true") {
      this.companyNoLabelAsterixTarget.classList.toggle("is-hidden");
      this.vatNoLabelAsterixTarget.classList.toggle("is-hidden");
      if (this.hasVatNoErrorBlockTarget) {
        this.toggleError(this.vatNoErrorBlockTarget)
      }
      if (this.hasCompanyNoErrorBlockTarget) {
        this.toggleError(this.companyNoErrorBlockTarget)
      }
    }
    this.organizationLabelAsterixTarget.classList.toggle("is-hidden");
    if (this.hasOrganizationErrorBlockTarget) {
      this.toggleError(this.organizationErrorBlockTarget)
    }
  }

  toggleError(errorElement) {
    errorElement.textContent = '';
    errorElement.classList.add = 'is-hidden';
  }

  sendAsGuest() {
    event.preventDefault();
    const sendButton = document.querySelector('.send-btn');
    const formId = sendButton.dataset["form"];
    const form = document.getElementById(formId);
    const method = form.getAttribute("data-method");
    const action = form.getAttribute("data-action");

    const first_name = document.querySelector('#' + formId + ' #first_name').value
    const last_name = document.querySelector('#' + formId + ' #last_name').value
    const organization = document.querySelector('#' + formId + ' #organization').value.trim()
    const locale = document.querySelector('#' + formId + ' #booking_locale').value
    const show_asterisk = document.querySelector('#' + formId + ' #booking_show_asterisk').value

    let dataToSend = {
      locale: locale,
      first_name: first_name,
      last_name: last_name,
      business_type: document.querySelector('#' + formId + ' #business_type').value,
      organization: organization !== '' ? organization : `${first_name} ${last_name}`,
      email: document.querySelector('#' + formId + ' #email').value,
      password: document.querySelector('#' + formId + ' #password').value,
      account_type: document.querySelector('#' + formId + ' #account_type').value,
      company_no: document.querySelector('#' + formId + ' #company_no').value,
      vat_no: document.querySelector('#' + formId + ' #vat_no').value,
      country: document.querySelector('#' + formId + ' #country').value
    };

    let that = this;

    $.ajax({
      url: action,
      type: method,
      dataType: "json",
      data: {
        booking: dataToSend
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      beforeSend: function() {
        document.querySelector('.loader')?.classList.remove('is-hidden');

        const requiredFields = [
          { selector: '#first_name', errorId: 'first-name-error' },
          { selector: '#last_name', errorId: 'last-name-error' },
          { selector: '#business_type', errorId: 'business_type-error' },
          { selector: '#email', errorId: 'email-error' },
          { selector: '#password', errorId: 'password-error' },
          { selector: '#account_type', errorId: 'account-type-error' },
          { selector: '#country', errorId: 'country-error' }
        ];

        const businessTypeValue = document.querySelector('#business_type').value.trim();
        if (businessTypeValue !== 'individual') {
          requiredFields.push({ selector: '#organization', errorId: 'organization-error' });
          if (show_asterisk === "true") {
            requiredFields.push({ selector: '#company_no', errorId: 'company-no-error' });
            requiredFields.push({ selector: '#vat_no', errorId: 'vat-no-error' });
          }
        } else {
          if (show_asterisk === "true") {
            that.toggleError(that.companyNoErrorBlockTarget)
            that.toggleError(that.vatNoErrorBlockTarget)
          }
          that.toggleError(that.organizationErrorBlockTarget)
        }

        let isValid = true;

        requiredFields.forEach(field => {
          const errorElement = document.getElementById(field.errorId);
          if (errorElement) {
            errorElement.textContent = '';
            errorElement.classList.add = 'is-hidden';
          }
        });

        requiredFields.forEach(field => {
          const value = document.querySelector(field.selector).value.trim();

          if (!value) {
            isValid = false;
            const errorElement = document.getElementById(field.errorId);
            const errorMessage = sendButton.dataset["errorMessage"];
            if (errorElement) {
              errorElement.textContent = errorMessage;
              errorElement.classList.remove('is-hidden');
            }
          }
        });

        if (!isValid) {
          return false;
        }
      }
    }).done((data) => {
      document.querySelector('.loader')?.classList.add('is-hidden')
      let asGuestModal = '#modal__as_guest'
      let verifyEmailModal = '#modal__verify_email'
      $(asGuestModal).modal('hide');
      $(verifyEmailModal).modal('show');
      window.location.href = '?guest_token=' + data.guest_token;
    }).fail((data) => {
      const errors = data?.responseJSON?.errors;

      for (const field in errors) {
        if (errors.hasOwnProperty(field)) {
          if (!errors[field]) continue;
          const errorMessages = Array.isArray(errors[field]) ? errors[field] : [errors[field]];
          const errorMessage = errorMessages.join(', ');
          $('#' + field + '-error').text(errorMessage).show();
        }
      }

      document.querySelector('.loader')?.classList.add('is-hidden')

      const signInButton = document.querySelector('.sign-in-btn');
      const checkConfirmation = document.querySelector('.check-confirmation');

      if (signInButton) {
        signInButton.classList.add('is-hidden')
      }
      if (checkConfirmation) {
        checkConfirmation.classList.add('is-hidden')
      }
      if (data?.responseJSON?.errors?.sign_in === true && signInButton) {
        signInButton.classList.remove('is-hidden')
      }
      if (data?.responseJSON?.errors?.resend_confirmation === true && checkConfirmation) {
        checkConfirmation.classList.remove('is-hidden')
      }
    })
  }
}
